import { gql } from '@apollo/client';

export const TERMS_OF_SERVICE = gql`
  query termsOfService {
    termsOfService {
      url
      revision
    }
  }
`;

export const GENERAL_SEARCH = gql`
  query generalSearch($input: GeneralSearchInput!, $page: Int = 0, $size: Int = 500) {
    generalSearch(input: $input, page: $page, size: $size) {
      total
      payload
      items {
        id
        name
        isAutocompleteEnabled
      }
    }
  }
`;

export const VALIDATE_INVITATION = gql`
  query validateSiteVaultInvitation($id: ID) {
    validateSiteVaultInvitation(id: $id) {
      isValid
      isClaimed
      studyName
      replyTo
      sponsorName
      email
    }
  }
`;

export const SEARCH_SIMILAR_SITES = gql`
  query searchSimilarSites($query: SimilarSiteSearchInput) {
    searchSimilarSites(query: $query) {
      total
      sites {
        usn
        address1
        address2
        name
        organization
        location {
          city
          country
          stateProvince
          postalCode
        }
        source
      }
    }
  }
`;

export const LOCATION_SUGGESTIONS = gql`
  query locationSuggestions($query: LocationSuggestionInput!) {
    locationSuggestions(query: $query) {
      key
      text
    }
  }
`;

export const LOCATION_COORDINATES_BY_KEY = gql`
  query locationCoordinatesByKey($query: LocationCoordinatesByKeyInput) {
    locationCoordinatesByKey(query: $query) {
      address
      state
      stateAbbr
      streetAddress
      postalCode
      city
      countryCode
      countryName
    }
  }
`;

export const GET_DUPLICATE_STATUS = gql`
  query getDuplicateStatus($id: ID) {
    getDuplicateStatus(id: $id)
  }
`;
